/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RecommendationPageContext =
  | 'default'
  | 'packaging';

export type UserProductRecommendationsQueryVariables = Exact<{
  userId: string;
  roleAssignmentId: string;
  supplierId?: string | null | undefined;
  limit?: number | null | undefined;
  pageContext?: Types.RecommendationPageContext | null | undefined;
  subFamily?: string | null | undefined;
}>;


export type UserProductRecommendationsQuery = { getUserProductRecommendations: { recommendations: Array<{ rank: number, company_id: string, sku: number, base_unit_sku: number }> } | null };


export const UserProductRecommendationsDocument = /*#__PURE__*/ gql`
    query UserProductRecommendations($userId: uuid!, $roleAssignmentId: uuid!, $supplierId: uuid, $limit: Int, $pageContext: RecommendationPageContext, $subFamily: String) {
  getUserProductRecommendations(
    user_id: $userId
    role_assignment_id: $roleAssignmentId
    supplier_id: $supplierId
    limit: $limit
    page_context: $pageContext
    sub_family: $subFamily
  ) {
    recommendations {
      rank
      company_id
      sku
      base_unit_sku
    }
  }
}
    `;

/**
 * __useUserProductRecommendationsQuery__
 *
 * To run a query within a React component, call `useUserProductRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProductRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProductRecommendationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleAssignmentId: // value for 'roleAssignmentId'
 *      supplierId: // value for 'supplierId'
 *      limit: // value for 'limit'
 *      pageContext: // value for 'pageContext'
 *      subFamily: // value for 'subFamily'
 *   },
 * });
 */
export function useUserProductRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<UserProductRecommendationsQuery, UserProductRecommendationsQueryVariables> & ({ variables: UserProductRecommendationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProductRecommendationsQuery, UserProductRecommendationsQueryVariables>(UserProductRecommendationsDocument, options);
      }
export function useUserProductRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProductRecommendationsQuery, UserProductRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProductRecommendationsQuery, UserProductRecommendationsQueryVariables>(UserProductRecommendationsDocument, options);
        }
// @ts-ignore
export function useUserProductRecommendationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserProductRecommendationsQuery, UserProductRecommendationsQueryVariables>): Apollo.UseSuspenseQueryResult<UserProductRecommendationsQuery, UserProductRecommendationsQueryVariables>;
export function useUserProductRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserProductRecommendationsQuery, UserProductRecommendationsQueryVariables>): Apollo.UseSuspenseQueryResult<UserProductRecommendationsQuery | undefined, UserProductRecommendationsQueryVariables>;
export function useUserProductRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserProductRecommendationsQuery, UserProductRecommendationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserProductRecommendationsQuery, UserProductRecommendationsQueryVariables>(UserProductRecommendationsDocument, options);
        }
export type UserProductRecommendationsQueryHookResult = ReturnType<typeof useUserProductRecommendationsQuery>;
export type UserProductRecommendationsLazyQueryHookResult = ReturnType<typeof useUserProductRecommendationsLazyQuery>;
export type UserProductRecommendationsSuspenseQueryHookResult = ReturnType<typeof useUserProductRecommendationsSuspenseQuery>;
export type UserProductRecommendationsQueryResult = Apollo.QueryResult<UserProductRecommendationsQuery, UserProductRecommendationsQueryVariables>;